import React from 'react';

export default function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero-grid-bg" aria-hidden="true"/>
      <div className="hero-inner">
        <div className="hero-text">
          <p className="hero-eyebrow">Global workforce cost intelligence</p>
          <h1 className="hero-headline">
            Know the cost.<br/>
            <span className="headline-accent">Win the deal.</span>
          </h1>
          <p className="hero-sub">
            Quoteology gives staffing firms, EOR providers and recruitment agencies instant,
            tax-accurate contractor cost breakdowns across 8 countries — so you quote with
            confidence and win more mandates.
          </p>
          <div className="hero-ctas">
            <a href="#contact" className="btn-primary">Request a demo</a>
            <a href="#features" className="btn-ghost">See how it works</a>
          </div>
          <p className="hero-strapline">8 Countries &nbsp;·&nbsp; Instant Calculations &nbsp;·&nbsp; Zero Surprises</p>
        </div>

        <div className="hero-visual" aria-hidden="true">
          <div className="breakdown-card">
            <div className="breakdown-header">
              <span className="breakdown-flag">🇯🇵</span>
              <div>
                <div className="breakdown-country">Japan — Tokyo</div>
                <div className="breakdown-rate">Bill rate ¥2,800/hr</div>
              </div>
              <span className="breakdown-badge">Actual Tax</span>
            </div>
            <div className="breakdown-rows">
              {[
                ['Gross annual salary',        '¥5,824,000'],
                ['Kyokai Kenpo (employer)',     '¥526,944'],
                ['Kosei Nenkin (employer)',     '¥536,768'],
                ['Employment Income Tax',      '¥291,200'],
                ['Resident Tax',               '¥582,400'],
              ].map(([label, val]) => (
                <div className="breakdown-row" key={label}>
                  <span>{label}</span><span>{val}</span>
                </div>
              ))}
              <div className="breakdown-row breakdown-row--muted">
                <span>Other employer costs</span><span>¥48,000</span>
              </div>
            </div>
            <div className="breakdown-total">
              <span>Total employer cost</span>
              <span className="breakdown-total-value">¥7,809,312</span>
            </div>
            <div className="breakdown-actions">
              <span className="action-chip">
                <DownloadIcon/> PDF
              </span>
              <span className="action-chip">
                <DownloadIcon/> Excel
              </span>
              <span className="action-chip compare">Compare countries</span>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-scroll-hint" aria-hidden="true"><span/></div>
    </section>
  );
}

function DownloadIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/>
    </svg>
  );
}
